<template>
  <span class="danger span-text-validation-danger v-enter-to">
    <small>
      <slot />
    </small>
  </span>
</template>
<script>
export default {
  name: 'VInvalidFeedback',
};
</script>
